module.exports = __webpack_public_path__ + "img/mont.b048c583.png";